import { defineMessages } from "react-intl"

export default defineMessages({
  cancel: {
    defaultMessage: "Cancel",
    id: "src.pages.LoginPage.cancel",
  },
  logout: {
    defaultMessage: "Logout",
    id: "src.pages.LoginPage.logout",
  },
  logoutMessage: {
    defaultMessage: "Are you sure you want to logout?",
    id: "src.pages.LoginPage.logoutMessage",
  },
})
